<template>
  <tr>
    <td class="clickable" :class="{'info': !isShortView}" @click="onPlayerSelected(playerKey)">
      <span v-if="player && player.name">{{player.name}}</span>
      <span v-if="match && match.now && match.now.striker == playerKey">&starf;</span>
    </td>
    <template v-if="!isShortView && player && playerInnings && playerInnings.batting">
      <td class="clickable hide-on-mobile " v-if="playerInnings.batting.dismissed && playerInnings.batting.out_str && playerInnings.batting.out_str.length > 1" @click="onBallSelected(playerInnings.batting.ball_of_dismissed)">{{playerInnings.batting.out_str}}</td>
      <td class="hide-on-mobile" v-else><span class="silent">not out</span></td>
      <td>{{playerInnings.batting.runs}}</td>
      <td>{{playerInnings.batting.balls}}</td>
      <td>{{playerInnings.batting.fours}}</td>
      <td>{{playerInnings.batting.sixes}}</td>
      <td>{{playerInnings.batting.strike_rate}}</td>
    </template>
    <template v-else>
      <td class="info" v-if="player && playerInnings && playerInnings.batting">
          {{playerInnings.batting.runs}}({{playerInnings.batting.balls}})
      </td>
      <td v-if="player && playerInnings && playerInnings.batting">
        <span>{{playerInnings.batting.fours}} <span class="silent">x4s</span></span>
        <span>{{playerInnings.batting.sixes}} <span class="silent">x6s</span></span>
      </td>
    </template>
  </tr>
</template>
<script>
export default {
  data () {
    return {
      innings: this.match.innings[`${this.teamI}_${this.inningsNumber}`]
    }
  },
  props: {
    match: Object,
    playerKey: String,
    inningsNumber: String,
    isShortView: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    player () {
      return this.match.players[this.playerKey]
    },

    playerInnings () {
      if (this.match.players && this.match.players[this.playerKey] && this.match.players[this.playerKey].match && this.match.players[this.playerKey].match.innings) {
        return this.match.players[this.playerKey].match.innings[this.inningsNumber]
      }
    }
  },
  methods: {
    onPlayerSelected (playerKey) {
      this.$emit('playerSelected', playerKey)
    },
    onBallSelected (ball) {
      this.$emit('ballSelected', ball)
    }
  }
}
</script>
